/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import CloseAction from './CloseAction/index'
import CloseButtonAction from './CloseButtonAction/index'
import HistoricalData from './HistoricalData/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import Title from 'DesignSystem/Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Categories/Category/Questions/Question/Actions/ShowHistoryAction/Content/ShowHistoryModal/Content"
  
}) {
let questionNameValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'name',
})
let constantData = ' - Historical Data'
let aggregateData = fromAggregate.join(questionNameValueData, constantData)
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 overflow="auto"
 height="auto"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
 data="question.name"
 data="' - Historical Data'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<HistoricalData
{...childProps}
  viewPath={`${viewPath}/HistoricalData`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<CloseButtonAction
  viewPath={`${viewPath}/CloseButtonAction`}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}